import { render, staticRenderFns } from "./company.vue?vue&type=template&id=5d38d9f2&scoped=true&"
import script from "./company.vue?vue&type=script&lang=js&"
export * from "./company.vue?vue&type=script&lang=js&"
import style0 from "./company.vue?vue&type=style&index=0&id=5d38d9f2&prod&lang=css&"
import style1 from "./company.vue?vue&type=style&index=1&id=5d38d9f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d38d9f2",
  null
  
)

export default component.exports